import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import { MultiSelect, MultiSelectProps, SelectMode } from './multi-select';
import { Badge } from '../../atoms/Badge/Badge';
import type { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

const options = (t: TFunction<'designSystem'>) => [
  {
    value: 'PASSED',
    label: <Badge label={t('passed')} status="good" />,
  },
  {
    value: 'FAILED',
    label: <Badge label={t('failed')} status="bad" />,
  },
];
export const StatusMultiSelect = ({
  icon,
  label,
  setValue,
  value,
  dataTestId,
  ...props
}: Omit<
  MultiSelectProps<ReturnType<typeof options>[number]>,
  'options' | 'mode' | 'label'
> &
  SelectMode & { label?: string }) => {
  const { t } = useTranslation('designSystem');
  return (
    <MultiSelect
      {...props}
      icon={icon || (ExclamationCircleIcon as React.FC<{ className?: string }>)}
      label={label || t('common:status')}
      options={options(t)}
      setValue={setValue as any}
      value={value as any}
      dataTestId={dataTestId}
    />
  );
};
